import React, { useState, useEffect } from "react";
import { question, serviceList } from "../../json/List";
import { InquiryForm } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { FaDollarSign } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import Header from "../../Common/Header";
import { handleApiError } from "../../Common/Helper";
const AboutMe = () => {
  const [id, setId] = useState(1);
  const [currentId, setCurrentId] = useState(1);

  const [data, setData] = useState([]);
  const [fallback, setFallback] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const validate = () => {
    const errors = {};

    if (!data.first_name?.trim()) {
      errors.first_name = "First name is required";
    }

    if (!data.last_name?.trim()) {
      errors.last_name = "Last name is required";
    }

    if (!data.email?.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "Email address is invalid";
    }

    if (!data.contact_number?.trim()) {
      errors.contact_number = "Contact number is required";
    } else if (!/^\d{10}$/.test(data.contact_number)) {
      errors.contact_number = "Contact number is invalid";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      // Form is valid, proceed with submission
      console.log("Form submitted", data);
      InquiryForm(data)
        .then((res) => {
          console.log(res);
          if (res.success && res.status_code === "200") {
            setTimeout(() => {
              navigate("/");
            }, [2000]);
            toast.success(
              "Thanks for your callback request. We’ll be in touch soon."
            );
          } else {
            handleApiError(res,navigate)
          }
        })
        .catch((err) => {
          toast.error(err.message);
          console.log(err);
        });
      // Reset form if needed

      setErrors({});
    }
  };
  const handleClick = () => {
    if (id === 9) {
      navigate("/"); // Redirect to the home route
    } else {
      setFallback(true); // Set fallback state to true
    }
  };
  console.log("id =>", id, "currentId =>", currentId);
  console.log("data =>", data);
  console.log("fallback =>", fallback);
  const handleClickFalse = (items) => {
    console.log("items =>", items);
    if (items.name == "live_in_australia") {
      setId(8);
    } else if (items.name === "everything_you_own_in_australia") {
      setId(8);
    } else if (items.name === "own_bussiness") {
      setId(7);
    } else if (items.name === "partner_need_will") {
      setId(9);
    }
  };
  return (
    <>
      <Toaster />
      <Header />
      <div
        className={`h-[10px] bg-RoyalPurple ${id === 1 && "w-[15%]"} ${
          id === 2 && "w-[25%]"
        } ${id === 3 && "w-[45%]"} ${id === 4 && "w-[75%]"} ${
          id === 5 && "w-[100%]"
        } rounded-r-full`}
      ></div>
      <div className="container">
        <div className="grid grid-cols-2 max-lg:grid-cols-1 h-[calc(100vh-110px)] w-full items-center">
          {id <= 7 ? (
            question?.map((items, index) => {
              return (
                items.id === id && (
                  <div key={items.id}>
                    <div>
                      <h1 className="text-[35px] lg:text-[50px] md:text-[35px] sm:text-[35px] font-bold ">
                        {items.title}
                      </h1>
                      {id == 7 ? (
                        <p>
                          Get 45 A$ off by sorting out your wills together. You
                          can change your mind later.
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <div className="grid grid-cols-2 max-sm:grid-cols-1 mt-[40px] gap-4">
                        <div
                          className="shadow-lg hover:text-[#7a3db6] hover:border-[#7a3db6] hover:border-2 cursor-pointer p-[30px] h-auto w-full hover:shadow-[rgba(122,61,82,0.50)_0px_5px_15px] shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px]"
                          style={{ transition: "all 0.5s" }}
                          onClick={(e) => {
                            setId(id === 7 ? 9 : items.id + 1);
                            setCurrentId(currentId + 1);
                            setData({ ...data, [items.name]: 1 });
                          }}
                          name={items.name}
                          value={1}
                        >
                          <p className="text-[20px] font-semibold text-center">
                            Yes
                          </p>
                          <p className="text-[14px] text-center text-slate-500 my-4">
                            {items.yes}
                          </p>
                        </div>
                        <div
                          className="shadow-lg hover:text-[#7a3db6] hover:border-[#7a3db6] hover:border-2 cursor-pointer p-[30px] h-auto w-full hover:shadow-[rgba(122,61,82,0.50)_0px_5px_15px] shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px]"
                          style={{ transition: "all 0.5s" }}
                          onClick={(e) => {
                            setId(items.id + 1);
                            setData({ ...data, [items.name]: 0 });
                            setCurrentId(currentId + 1);
                            handleClickFalse(items);
                          }}
                          name={items.name}
                          value={0}
                        >
                          <p className="text-[20px] font-semibold text-center">
                            No
                          </p>
                          <p className="text-[14px] text-center text-slate-500 my-4">
                            {items.no}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div>
                      {items.id !== 1 ? (
                        <div className="fixed">
                          <button
                            onClick={() => {
                              setId(items.id - 1);
                              setCurrentId(currentId - 1);
                            }}
                            className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] mt-5 text-slate-500"
                          >
                            <FaAngleLeft />
                            Back 
                          </button>
                        </div>
                      ) : (
                        <Link to={"/dashboard"}>
                          <div className="fixed">
                            <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] mt-5 text-slate-500">
                              <FaAngleLeft />
                              Back
                            </button>
                          </div>
                        </Link>
                      )}
                    </div>
                  </div>
                )
              );
            })
          ) : !fallback ? (
            <div>
              <h2 className="text-[24px] sm:text-[30px] md:text-[35px] lg:text-[40px] font-bold">
                3 things WillsGuru's phone <br />
                service can do for you
              </h2>
              <div className="mt-5">
                {serviceList.map((items) => (
                  <div className="py-2 flex items-center gap-5" key={items.id}>
                    <div className="w-[40px] h-[40px] sm:w-[45px] sm:h-[45px] md:w-[50px] md:h-[50px] lg:w-[60px] lg:h-[60px] flex-shrink-0 my-2">
                      <img
                        src={items.image}
                        className="w-full h-full object-cover"
                        alt="list"
                      />
                    </div>
                    <div>
                      <p className="text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] font-bold ">
                        {items.title}
                      </p>
                      <p className="text-[14px] sm:text-[14px] md:text-[16px] lg:text-[16px] text-[#727278] ">
                        {items.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4">
                <button
                  onClick={handleClick}
                  className="w-full py-3 text-white font-bold bg-primary rounded  hover:bg-[#fff] hover:border-2 hover:shadow-lg hover:text-[#7a3db6]"
                >
                  Continue Online
                </button>
              </div>
              <button
                onClick={() => {
                  setId(currentId - 1);
                  setCurrentId(currentId - 1);
                }}
                className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500 mt-5"
              >
                <FaAngleLeft />
                Back
              </button>
            </div>
          ) : (
            <div>
              <h2 className="text-[30px] sm:text-[30px] md:text-[35px] lg:text-[40px] font-bold my-2">Book a free callback</h2>
              <p className="text-slate-500 text-[16px] mb-3">
                Please leave your name and number below, then we’ll give you a
                quick call to book you in with one of our specialists.
              </p>
              <div>
                <div className="my-2">
                  <div className="mb-5">
                    <input
                      type="text"
                      className="w-full py-3 px-2 border-2 rounded-lg"
                      placeholder="Enter Your First Name"
                      name="first_name"
                      onChange={(e) =>
                        setData({ ...data, [e.target.name]: e.target.value })
                      }
                    />
                    {errors.first_name ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {errors.first_name}
                        </p>
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-5">
                    <input
                      type="text"
                      className="w-full py-3 px-2 border-2 rounded-lg"
                      placeholder="Enter Your Last Name"
                      name="last_name"
                      onChange={(e) =>
                        setData({ ...data, [e.target.name]: e.target.value })
                      }
                    />
                    {errors.last_name ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {errors.last_name}
                        </p>
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-5">
                    <input
                      type="text"
                      className="w-full  py-3 px-2 border-2 rounded-lg"
                      placeholder="Enter Your Email"
                      name="email"
                      onChange={(e) =>
                        setData({ ...data, [e.target.name]: e.target.value })
                      }
                    />
                    {errors.email ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {errors.email}
                        </p>
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-5">
                    <input
                      type="text"
                      className="w-full  py-3 px-2 border-2 rounded-lg"
                      placeholder="Enter Your Contact Number"
                      name="contact_number"
                      onChange={(e) => {
                        // if (
                        //   !/^\d*$/.test(e.target.value) ||
                        //   e.target.value.length >= 10
                        // ) {
                        //   return errors.contact_number;
                        // }
                        setData({ ...data, [e.target.name]: e.target.value });
                      }}
                    />
                    {errors.contact_number ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {errors.contact_number}
                        </p>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <button
                      className="w-full py-3 mt-3 text-white font-bold bg-primary rounded  hover:bg-[#fff] hover:border-2 hover:shadow-lg hover:text-[#7a3db6]"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Book a Free CallBack
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={() => setFallback(false)}
                      className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500 mt-5"
                    >
                      <FaAngleLeft />
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="h-[calc(100vh-110px)] 2xl:w-[700px] lg:w-[500px] max-lg:hidden col-1 flex justify-center">
            <img
              src="/assets/images/3.png"
              alt="wills-guru-logo-white"
              className="h-full object-cover"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutMe;
